// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@awc/App/Store/Reducers";
import { xScreen } from "@awc/XDL/Utilities";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { injectCss } from "@insite/mobius/utilities";
import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import MobiusStyledComponentProps from "@insite/mobius/utilities/MobiusStyledComponentProps";
import React, { FC } from "react";
import styled, { css } from "styled-components";

const enum headerTypeProps {
    header = "header",
    compactHeader = "compactHeader",
}

interface XngStickyProps {
    css?: StyledProp<XngStickyComponentProps>;
    stickyOffset?: string;
    stopBreakpoint?: "xs" | "sm" | "md" | "lg" | "xl";
    headerType?: "header" | "compactHeader";
    [key: string]: any;
}

export type XngStickyComponentProps = MobiusStyledComponentProps<"div", XngStickyProps>;

export const XngStickyWrapper = styled.div<XngStickyComponentProps>`
    position: sticky;
    top: ${({ stickyOffset }) => `${stickyOffset}`};
    ${({ stopBreakpoint }) => css`
        ${xScreen("lte", stopBreakpoint || "sm")} {
            position: static;
        }
    `};
    @media print {
        position: static;
    }

    ${injectCss}
`;

const XngSticky: FC<XngStickyProps> = ({
    className = "xng-sticky",
    stopBreakpoint = "sm",
    headerType = "compactHeader",
    ...props
}) => {
    const stickyHeader = useAppSelector(state => {
        if (props.headerType === headerTypeProps.compactHeader) {
            return (state as CustomAppState).xHeader.stickyHeader || "10px";
        }
        return (state as CustomAppState).xHeader.headerHeight || "10px";
    });

    return (
        <XngStickyWrapper
            className={className}
            stopBreakpoint={stopBreakpoint}
            headerType={headerType}
            {...props}
            stickyOffset={`${parseFloat(stickyHeader) + 10}px`}
        />
    );
};

export default XngSticky;
